import React from "react";
import { AnimatePresence } from "framer-motion";
//Styles
import SideContainer from "./styles";
//Interface
import { SideContainerAnimatedInterface } from "./SideContainerInterface";

const SideContainerAnimated = ({
    children, 
    isVisible
}: SideContainerAnimatedInterface
): React.ReactElement => {
    return(
        <AnimatePresence>
            {
                isVisible && (
                    <SideContainer
                        visible={false} 
                        className="column-side"
                        layout
                        initial={{ 
                            display: "none",
                            opacity: 0,
                            x: 300,
                            y: "0%"
                        }}
                        animate={{
                            display: "flex",
                            opacity: 1,
                            x: 0,
                            y: 0
                        }}
                        transition={{
                            // delay: 0.2,
                            type: "tween"
                        }}
                        exit={{ 
                            x: 300,
                            y: "-100%",
                            opacity: 0,
                            display: "none"
                        }}
                    >
                        { children }
                    </SideContainer>
                )
            }
        </AnimatePresence>
    )
}

export default SideContainerAnimated;